import React, { useState, useEffect, useReducer, useContext } from 'react';
import useAuth from './auth/useAuth.js';
import axios from 'axios';
import Check from '@material-ui/icons/Check';
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import Switch from '@material-ui/core/Switch';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Alert from '@material-ui/lab/Alert';
import CustomButton from './CustomButton.js';
import AdminStyles from './admin/AdminStyles.js';


const AccountService = {
    get: (request) => {
        return axios.get("api/user", {}, { withCredentials: true });
    },
    update: (request) => {
        return axios.put("api/user", request, { withCredentials: true });
    },
};
const Account = (props) => {
    const auth = useAuth();
    const classes = AdminStyles();
    const [errors, setErrors] = useState({});
    const [error, setError] = useState(null);
    const [formInput, setFormInput] = useReducer((state, newState) => ({ ...state, ...newState }), auth.user);
    
    const handleEditConfirm = (e) => {
        if (e) e.preventDefault();
        return AccountService.update(formInput).then((response) => {
            setFormInput({ ["id"]: response.data.id });
            let formInp = { ...formInput };
            formInp.id = response.data.id;    
            setError("");
            setErrors({});
            auth.signin().then(response => { props.onClose(); });        
     
        }).catch((error) => {
            if ('response' in error && 'data' in error.response) {
                setError(error.response.data.title);
                setErrors(error.response.data.errors);
            }
        });
    };
    const handleInput = (e) => { setFormInput({ [e.target.name]: e.target.value }); };
    const handleInputCheckbox = (e) => { setFormInput({ [e.target.name]: e.target.checked }); };
    return (
        <>
            <Dialog open={props.open} onClose={props.onClose} fullWidth maxWidth="sm" aria-labelledby="form-dialog-title">
                <DialogTitle id="form-dialog-title">Update my details</DialogTitle>
                <DialogContent>
                    {props.mustsave ? <div className="error">This is the first time you have logged in to EO Online. Please complete your details below before you proceed. This information is used to record your EO Online completion.<br /><br /></div> : ""}
                    <form noValidate autoComplete="off" onSubmit={handleEditConfirm}>
                        {error ? <Alert severity="error">{error}</Alert> : ""}                      
                        <div>{formInput.givenName == "" ? <Alert severity="error">First Name is required</Alert> : null}<TextField fullWidth name="givenName" label="First Name" defaultValue={formInput.givenName} error={'GivenName' in errors} onChange={handleInput} required  variant="outlined" /></div>
                        <div><TextField fullWidth name="surname" label="Last Name" defaultValue={formInput.surname} error={'Surname' in errors} onChange={handleInput} required variant="outlined" /></div>
                        <div>{formInput.orgUnit == "" ? <Alert severity="error">Organisation unit is required</Alert> : null}<TextField fullWidth name="orgUnit" label="Organisation Unit" defaultValue={formInput.orgUnit} error={'orgUnit' in errors} onChange={handleInput} required variant="outlined" /></div>
                        <div>{formInput.idNumber == "" ? <Alert severity="error">ID Number is required</Alert> : null}<TextField fullWidth name="idNumber" label="ID Number" defaultValue={formInput.idNumber} error={'idNumber' in errors} onChange={handleInput} required variant="outlined" /></div>                        
                        <FormControlLabel className={classes.switchLabel} label="I'm a student of my institution" control={
                            <Switch checked={formInput.isStudent} onChange={handleInputCheckbox} name="isStudent" color="primary" />} />
                    </form>
                </DialogContent>
                <DialogActions>
                    <CustomButton onClick={handleEditConfirm} color="primary" variant="contained" startIcon={<Check />}>Save</CustomButton>
                    {!props.mustsave ? <CustomButton onClick={() => { setFormInput(auth.user); props.onClose(); }} color="default" variant="outlined">Cancel</CustomButton> : null}
                </DialogActions>
            </Dialog>
            </>
            )


};

export default Account;
export { AccountService };
